const assetListFilterOptions = {
  allResults: "AllResults",
  filteredAssets: "FilteredAssets",
  selectedAssets: "SelectedAssets",
  specificPortfolio: "SpecificPortfolio",
};

export { assetListFilterOptions };
